import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Pagination from "@mui/material/Pagination";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudDownload, faSearch } from '@fortawesome/free-solid-svg-icons';
import TobNavBar from "../../../DashBaord/Top_navbar";
import ShowData from "../../../../components/ShowData";
import { Link, useNavigate } from "react-router-dom";
import SkeltonList from "../../../../components/SkeltonEffect/list";
import { userInventoryList } from "../../../../controllers/V1/products/productController";
import { getPage } from "../../../../controllers/common";
import ExportPopup from './Export';
import { usePermissions } from "../../../../controllers/PermissionContext";
import { list as pickUpPointsList } from "../../../../controllers/V1/cms/pickupPointsDataController";
import AddBulkInventory from "./AddBulkInventory";
function VendorList(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

VendorList.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const PERMISSION = usePermissions("productInventory");

  const [isExportShow, setExportShow] = useState(false);
  const handleExportDrawer = () => setExportShow(!isExportShow);

  const [isBulkAddShow, setBulkAddShow] = useState(false);
  const handleBulkAddShow = () => setBulkAddShow(!isBulkAddShow);

  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  /************************************************************************************* */
  const [isLoading, setIsLoading] =useState(true);
  const navigate = useNavigate();
  const targetRef = useRef(null);
  
  const [currentPage, setCurrentPage] = useState(1);
  const [ALLLISTDATA, setListData] = useState([]);
  const [TOTALPAGES, setTotalPages] = useState(1);
  const [LIMIT, setLimit] = useState(10);
  const [SKIP, setSkip] = useState(0);
  const [pageType, setPageType] = useState("Users");
  const [searchText, setSearchText] = useState('');

  const [pickUpPointsListData, setPickUpPointsListData] = useState([]);
  const [pickUpPointsTotalPages, setPickUpPointsTotalPages] = useState(1);
  const [pickUpPointsLimit, setPickUpPointsLimit] = useState(10);
  const [pickUpPointsSkip, setPickUpPointsSkip] = useState(0);
  const [pickUpPointsSearchText, setPickUpPointsSearchText] = useState('');

  const getPickUpPointsList = async () => {
    try {
      setIsLoading(true);
      setPickUpPointsListData([]);
      const options = {
        type: "",
        condition: {
          ...(pickUpPointsSearchText ? {
            $or: [
              { name: { $regex: pickUpPointsSearchText, $options: "i" } },
              { address: { $regex: pickUpPointsSearchText, $options: "i" } },
              { mobile: { $regex: pickUpPointsSearchText, $options: "i" } },
            ]
          } : null),
          status : "A"
        },
        select: {},
        sort: { _id: -1 },
        skip: pickUpPointsSkip ? pickUpPointsSkip : 0,
        limit: pickUpPointsLimit ? parseInt(pickUpPointsLimit) : 10,
      };
      const listData = await pickUpPointsList(options);
      if (listData.status === true) {
        if (listData.result.length > 0) {
          setPickUpPointsListData(listData?.result);
          setPickUpPointsTotalPages(getPage(listData?.count, pickUpPointsLimit))
        } else {
          setPickUpPointsListData([]);
          setPickUpPointsTotalPages(getPage(1))
        }
      } else {
        setPickUpPointsListData([]);
      }
      setIsLoading(false);
    } catch (error) {
      console.log('error : ', error);
      setIsLoading(false);
    }
  } //End

  /*********************************************************
   *  This function is use to fetch vendor list
   *********************************************************/
  const getList = async () => {
    try {
      setIsLoading(true);
      setListData([]);
      const regex = /^\d+$/;
      let isNumeric = false;
      if(regex.test(searchText)) {
        isNumeric = true;
      }
      const options = {
        type: "",
        condition: { 
          ...searchText && { 
            $or: [
              { users_type: { $regex: searchText, $options: "i" } },
              { users_name: { $regex: searchText, $options: "i" } },
              { last_name: { $regex: searchText, $options: "i" } },
              { area: { $regex: searchText, $options: "i" } },
              ...(isNumeric ? [{ pos_number: parseInt(searchText) }] : []),
              ...(isNumeric ? [{ users_mobile: parseInt(searchText) }] : []),
            ]
          } 
        },
        select: {},
        sort: { _id: -1 },
        skip: SKIP ? SKIP : 0,
        limit: LIMIT ? parseInt(LIMIT) : 10,
      };
      const listData = await userInventoryList(options);
      if (listData.status === true) {
        if (listData.result.length > 0) {
          setListData(listData?.result);
          setTotalPages(getPage(listData?.count, LIMIT))
        } else {
          setListData([]);
          setTotalPages(getPage(1))
        }
      } else {
        setListData([]);
      }
      setIsLoading(false);
    } catch (error) {
      console.log('error : ', error);
      setIsLoading(false);
    }
  }; //End

  /*********************************************************
   *  This function is for handle page change
   *********************************************************/
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
    setSkip((newPage - 1) * LIMIT);
    targetRef.current.scrollIntoView({
      behavior: "smooth",
    });
  };

  const handlePickUpPointsPageChange = (event, newPage) => {
    setPickUpPointsSkip(newPage);
    setPickUpPointsSkip((newPage - 1) * pickUpPointsLimit);
    targetRef.current.scrollIntoView({
      behavior: "smooth",
    });
  } //End 

  /*********************************************************
   *  This function will load when page load and with dependency update
   *********************************************************/
  useEffect(() => {
    if(pageType === "Users"){ 
      getList();
    } else if(pageType === "Pick Up Points"){
      getPickUpPointsList();
    }
    targetRef.current.scrollIntoView({
      behavior:'smooth',
    });
    document.title = `Orbit Kuwait || ${pageType} list`;
  }, [currentPage, LIMIT, pageType, pickUpPointsSkip, pickUpPointsLimit]);

  const handleAddEditInventory = (items) => {
    if(PERMISSION?.fullAccess === 'Y' || PERMISSION?.list === 'Y'){
      navigate('/product/inventory/addeditdata', { state: {...items, pageType: pageType} });
    }
  }

  const handleSearchChange = (e) => {
    try {
      const {key, value} = e.target;
      setSearchText(value);
    } catch (error) {
      
    }
  }

  const handleSearchChangePickUpPoints = (e) => {
    try {
      const {value} = e.target;
      setPickUpPointsSearchText(value);
    } catch (error) {
      console.log('error : ', error);
    }
  }
  const handleSearch = (e) =>{
    e.preventDefault();
    try {
      getList();
    } catch (error) {
      
    }
  }

  const handleSearchPickUpPoints = (e) =>{
    e.preventDefault();
    try {
      setPickUpPointsSearchText(e.target.value);
      setPickUpPointsSkip(0);
      setPickUpPointsLimit(10);
      getPickUpPointsList();
    } catch (error) {
      
    }
  }
  const inventoryUserList = () => {
    return (
      <VendorList>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <form onSubmit={handleSearch}>
            <div className="inventory_all_tabs">
              <input type="text" name="slug" id="slug" placeholder="Search user" value={searchText || ""} onChange={handleSearchChange} className="form-control categories_select_tg_enter_product" />
              <button className="btn btn-primary inventory_save_button" onClick={handleSearch}> <FontAwesomeIcon icon={faSearch}/> Search </button>
            </div>
          </form>
        </Box>
        <div>
          <div id="content-wrapper" className="d-flex flex-column">
            <div className="card shadow mb-4">
              <div className="card-body pt-0">
                <div className="table-responsive">
                  <table
                    className="table table-bordered"
                    id="dataTable"
                    width="100%"
                    cellspacing="0"
                  >
                    <thead>
                      <tr>
                        <th>Sl. No.</th>
                        <th>User's Type</th>
                        <th>User's Details</th>
                        <th>POS Details</th>
                        <th>Bind With</th>
                        <th>Area</th>
                        <th>Product NOS.</th>
                        <th>Available B-Points</th>
                      </tr>
                    </thead>
                    <tbody>
                      {ALLLISTDATA?.length > 0 ? (
                        ALLLISTDATA.map((items, index) => (
                          <>
                            <tr key={index} onDoubleClick={()=>handleAddEditInventory(items)} >
                              <td>{SKIP + index + 1}</td>
                              <td>{items?.users_type}</td>
                              <td className="admin_user_list_date"> 
                                <span>{`${items?.users_name} ${items?.last_name}`}</span><br/>
                                <span>{items?.users_mobile}</span><br/>
                                {items?.users_email && (<span>{items?.users_email}</span>)}
                              </td>

                              {items?.pos_number ? (
                                <td>{items.pos_number}</td>
                              ):(
                                <td> N/A </td>
                              )}

                              <td>
                                {items?.bind_person_name} <br/> 
                                {items?.bind_user_type}
                              </td>
                              <td className="admin_user_list_date">{items?.area}</td>
                              <td className="admin_user_list_date">{items?.inventory_count}</td>
                              <td className="admin_user_list_date">{items?.availableArabianPoints?.toFixed(2) || 0}</td>
                            </tr>
                          </>
                        ))
                      ) : isLoading ? <SkeltonList row={5} col={8} /> : <tr> 
                          <td colspan="11" className="img-center" >No data found !</td> 
                      </tr>}
                    </tbody>
                  </table>
                  <div className="table_pagination_sales_order">
                    <Pagination
                      count={TOTALPAGES}
                      onChange={handlePageChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </VendorList>
    )
  }

  const inventoryPickUpPointsList = () => {
    return (
      <VendorList>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <form onSubmit={handleSearchPickUpPoints}>
            <div className="inventory_all_tabs">
              <input type="text" name="slug" id="slug" placeholder="Search pick-up point" value={pickUpPointsSearchText || ""} onChange={handleSearchChangePickUpPoints} className="form-control categories_select_tg_enter_product" />
              <button className="btn btn-primary inventory_save_button" onClick={handleSearchPickUpPoints}> <FontAwesomeIcon icon={faSearch}/> Search </button>
            </div>
          </form>
        </Box>
        <div>
          <div id="content-wrapper" className="d-flex flex-column">
            <div className="card shadow mb-4">
              <div className="card-body pt-0">
                <div className="table-responsive">
                  <table
                    className="table table-bordered"
                    id="dataTable"
                    width="100%"
                    cellspacing="0"
                  >
                    <thead>
                      <tr>
                        <th>Sl. No.</th>
                        <th>Name</th>
                        <th>Mobile</th>
                        <th>Address</th>
                      </tr>
                    </thead>
                    <tbody>
                      {pickUpPointsListData?.length > 0 ? (
                        pickUpPointsListData.map((items, index) => (
                          <>
                            <tr key={index} onDoubleClick={()=>handleAddEditInventory(items)} >
                              <td>{SKIP + index + 1}</td>
                              <td>{`${items?.name}`}</td>
                              <td>{items?.mobile}</td>
                              <td>{items?.address}</td>
                            </tr>
                          </>
                        ))
                      ) : isLoading ? <SkeltonList row={5} col={8} /> : <tr> 
                          <td colspan="11" className="img-center" >No data found !</td> 
                      </tr>}
                    </tbody>
                  </table>
                  <div className="table_pagination_sales_order">
                    <Pagination
                      count={pickUpPointsTotalPages}
                      onChange={handlePickUpPointsPageChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </VendorList>
    )
  }

  return (
    <>
      <div className="container-fluid" ref={targetRef}>
        <TobNavBar title={`${pageType} list`} />
        <div className="inventory_tabs_main_div">
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <div className="inventory_all_tabs">
                <div className="all_tabs_value">
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    className="item_tabs_main_container"
                  >
                    <Tab
                      label="Users"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => setPageType("Users")}
                    />
                    <Tab
                      label="Pick Up Points"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => setPageType("Pick Up Points")}
                    />
                  </Tabs>
                </div>
                <div className="fa_filter_rating_review filter_img_and_add_btn_main">
                  <div className="inventory_filter_div">
                    <ShowData setLimit={setLimit} limit={LIMIT}/>
                  </div>
                  {pageType === "Users" && (
                    <div className="inventory_filter_div" 
                      onClick={handleExportDrawer}
                    >
                      <FontAwesomeIcon icon={faCloudDownload} />
                      <Link
                        to={false}
                        className="filter_btn_invontry_rating_review"
                      >
                        Export
                      </Link>
                    </div>
                  )}

                  <div className="inventory_filter_div" 
                    onClick={handleBulkAddShow}
                  >
                    <button className="btn btn-primary inventory_save_button" onClick={handleSearch} style={{width : '80px'}}>Add </button>
                  </div>

                  
                </div>
              </div>
            </Box>  
            {pageType === "Users" && inventoryUserList()}
            {pageType === "Pick Up Points" && inventoryPickUpPointsList()}
          </Box>
        </div>
      </div>
      {/* Export*/}
      <ExportPopup popUpOpen={isExportShow} togglePopUp={handleExportDrawer} type={pageType} />
      <AddBulkInventory popUpOpen={isBulkAddShow} togglePopUp={handleBulkAddShow} type={pageType} />
    </>
  );
}
